import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Camera, Sparkles } from "lucide-react";
import { ShopItemCard } from "@/components/fsl/Shop";
import { useCart } from "@/context/CartContext";
import { api } from "@/lib/api";

export function ChildrenPhotos() {
  const [data, setData] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const cart = useCart();
  useEffect(() => {
    api.get("/me/children-photos").then((r) => { setData(r.data); if (r.data.new > 0) api.post("/me/children-photos/seen").catch(() => {}); }).catch(() => setData({ items: [], new: 0 }));
  }, []);
  if (!data || data.items.length === 0) return null;
  const items = showAll ? data.items : data.items.slice(0, 8);
  const kids = [...new Map(data.items.filter((i) => i.child_id).map((i) => [i.child_id, i])).values()];
  const buy = (it) => cart.add({ id: it.id, title: it.title, price: it.price, kind: it.kind, image_url: it.preview_url, scope: it.tournament_slug });
  return (
    <section id="foto-figli" data-testid="fan-children-photos">
      <h2 className="fsl-section-title mb-1 flex items-center gap-2"><Camera className="h-5 w-5 text-fsl-gold" /> Le foto dei miei figli{data.new > 0 && <span className="ml-1 h-6 px-2 rounded-full bg-fsl-gold text-ink-950 text-[11px] font-bold inline-flex items-center gap-1 num" data-testid="fan-children-photos-new"><Sparkles className="h-3 w-3" /> {data.new} {data.new === 1 ? "nuova" : "nuove"}</span>}</h2>
      <p className="text-xs text-fsl-slate mb-3">Scatti e video in cui sono taggati i tuoi bambini o la loro squadra: anteprima sfocata, originale in alta qualità dopo l'acquisto. Ricevi un avviso ogni volta che il fotografo ne carica di nuove.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="fan-children-photos-grid">
        {items.map((it) => (
          <div key={it.id} className="relative space-y-1">
            {it.is_new && <span className="absolute z-10 top-2 right-2 h-6 px-2 rounded-full bg-fsl-gold text-ink-950 text-[10px] font-bold uppercase" data-testid={`fan-photo-new-${it.id}`}>Nuova</span>}
            <ShopItemCard it={it} onBuy={buy} />
            <div className="text-[10px] text-fsl-slate truncate px-1">{it.via === "player" ? `Con ${it.child_name}` : `Squadra di ${it.child_name}`} · {it.tournament_name}</div>
          </div>
        ))}
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-3 text-xs">
        {data.items.length > 8 && <button type="button" className="text-fsl-gold hover:underline" onClick={() => setShowAll((v) => !v)} data-testid="fan-children-photos-toggle">{showAll ? "Mostra meno" : `Mostra tutte (${data.items.length})`}</button>}
        {kids.map((k) => <Link key={k.child_id} to={`/tornei/${k.tournament_slug}/foto?giocatore=${k.child_id}`} className="text-fsl-slate hover:text-fsl-gold" data-testid={`fan-children-photos-link-${k.child_id}`}>Tutte le foto di {k.child_name} →</Link>)}
      </div>
    </section>
  );
}
